export const top20PartWise = (apiData: any) => {
  const output = [];
  let totalRejection = 0;
  for (const PartName in apiData) {
    const rejectionCount = apiData[PartName].reduce(
      (sum: number, num: number) => sum + num,
    );
    totalRejection += rejectionCount;
    if (rejectionCount > 0) {
      output.push({
        PartName,
        partCountDefectWise: apiData[PartName],
        rejectionCount,
        cummulativeRejection: 0,
        cummPercenatge: '',
      });
    }
  }
  output.sort((a, b) => b.rejectionCount - a.rejectionCount);
  let cumCount = 0;
  for (const item of output) {
    cumCount += item.rejectionCount;
    item.cummulativeRejection = cumCount;
    item.cummPercenatge = ((cumCount * 100) / totalRejection).toFixed(2);
  }
  if (output.length > 10) return output.slice(0, 10);
  else return output;
};

export const getAllPartWise = (apiData: any) => {
  const output = [];
  let totalRejection = 0;
  for (const PartName in apiData) {
    const rejectionCount = apiData[PartName].reduce(
      (sum: number, num: number) => sum + num,
    );
    totalRejection += rejectionCount;
    if (rejectionCount > 0) {
      output.push({
        PartName,
        partCountDefectWise: apiData[PartName],
        rejectionCount,
        cummulativeRejection: 0,
        cummPercenatge: '',
      });
    }
  }
  output.sort((a, b) => b.rejectionCount - a.rejectionCount);
  let cumCount = 0;
  for (const item of output) {
    cumCount += item.rejectionCount;
    item.cummulativeRejection = cumCount;
    item.cummPercenatge = ((cumCount * 100) / totalRejection).toFixed(2);
  }
  return output;
};
